import { render } from "./AppSettings.vue?vue&type=template&id=a2a1d92e&ts=true"
import script from "./AppSettings.vue?vue&type=script&lang=ts"
export * from "./AppSettings.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/user/Desktop/kafka/paletteiot/pletteiotweb/PaletteIoTDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__